import { Query } from "@datorama/akita";
import { singleton } from "tsyringe";

import ReviewsTranslationsStore, {
    ReviewsTranslationState,
} from "../stores/ReviewsTranslationsStore";

@singleton()
class ReviewsTranslationQuery extends Query<ReviewsTranslationState> {
    constructor(protected store: ReviewsTranslationsStore) {
        super(store);
    }

    isLocaleSupported$ = this.select((state) => state.isLocaleSupported);
    checkLocaleStatus$ = this.select(
        (state) => state.checkLocaleStatus
    );
    translations$ = this.select((state) => state.translations);
    pendingIds$ = this.select((state) => state.pendingIds);
    status$ = this.select((state) => state.status);
    error$ = this.selectError();
}

export default ReviewsTranslationQuery;
